const tr = {
  logsReports: {
    attributes: {
      date: 'Data',
      id: 'ID',
      name: 'Nome',
      action: 'Ação',
      user: 'Usuário',
      owner: 'Responsável',
      key: 'Chave',
    },
    extras: {
      date_init: 'Data de inicio',
      show: 'Vizualiando log',
      date_end: 'Data final',
      search: 'Digite o nome',
      type: 'Tipo',
      considerAtendent: 'Atendente',
      considerDoctor: 'Médico',
      considerMarketing: 'Marketing',
      considerAdmin: 'Admin',
      considerInsertion: 'Inserção',
      considerUpdate: 'Atualização',
      considerDelete: 'Exclusão',
      considerDocumentStatus: 'Status de Documentos',
    },
  },
};

export default tr;
